import { IdictValueList, IbatchDictValuesRes, IdictValueListItem } from './types';

import http from '@/core/http/index';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';

// 字典值 - 列表
export const dictValueList = (data: Partial<IdictValueList>) => {
  const url = '/ufg/web/v1/dict-value/list';
  return http.post<IdictValueListItem[]>({
    url,
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 字典值 - 批量
export const batchDictValues = (data: string[]) => {
  const url = '/ufg/web/v1/dict-value/batch-list';
  return http.post<IbatchDictValuesRes[]>({
    url,
    data: { dictCodes: data },
    loading: true,
    isNotCancel: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
